module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "contentFooter"
  }, [_c('div', {
    staticClass: "container_flex contentFooter__container"
  }, [_c('div', {
    staticClass: "contentFooter__logoWrap"
  }, [_c('router-link', {
    staticClass: "contentFooter__logo",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n        resursable\n      ")])], 1), _vm._v(" "), _c('p', {
    staticClass: "contentFooter__big"
  }, [_vm._v("+38(050) 77-23-169")]), _vm._v(" "), _c('p', {
    staticClass: "contentFooter__big"
  }, [_vm._v("pogidaevmo@gmail.com")]), _vm._v(" "), _c('nav', {
    staticClass: "nav",
    attrs: {
      "role": "nav"
    }
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      staticClass: "nav__item contentFooter__nav",
      attrs: {
        "to": '/' + item
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "container_flex contentFooter__bottomContainer"
  }, [_c('a', {
    staticClass: "contentFooter__resume",
    attrs: {
      "href": "https://max-im.github.io/"
    }
  }, [_vm._v("\n      Max Pozhidayev\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contentFooter__social"
  }, [_c('ul', _vm._l((_vm.social), function(item) {
    return _c('li', {
      staticClass: "contentFooter__socialList"
    }, [_c('a', {
      staticClass: "contentFooter__socialLink",
      attrs: {
        "href": item.link
      }
    }, [_c('img', {
      staticClass: "contentFooter__socialImg",
      attrs: {
        "src": './src/assets/icons/' + item.img,
        "alt": item.name
      }
    })])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a58eac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentFooter.vue
// module id = 75
// module chunks = 0